export default __webpack_public_path__ + "static/media/rupee-gray-color-icon.9d8d3fd6.svg";